import React, { useContext, useEffect, useState } from "react"
import { GrStatusGood } from "react-icons/gr"
import GeneralModal from "../../../components/dialogs/GeneralModal"
import ToDoListService from "../../../libs/api/services/ToDoListService"
import ToDoListWorkFlows from "../../../libs/api/services/ToDoListWorkFlows"
import CommonFunctionsContext from "../../common/CommonFunctionsProvider"

const ToDoListContext = React.createContext()

export const ToDoListProvider = ({ children }) => {
    const { showError, showToast } = useContext(CommonFunctionsContext)
    const [modal, setModal] = useState({ show: false, icon: undefined, title: undefined, component: undefined })
    const [ToDoLists, setToDoLists] = useState([])
    const [loading, setLoading] = useState(false)

    const LoadToDoLists = async () => {
        // console.log('----------------------------LoadToDoLists ************')
        setLoading(true)
        var res = await ToDoListService.ListAllToDoListsForUser()
        // console.log('LoadToDoLists', JSON.stringify(res))
        setToDoLists(res)
        setLoading(false)
    }

    useEffect(() => { LoadToDoLists() }, [])

    const GetItemDetails = async (ItemId) => await ToDoListService.GetItemDetails(ItemId).catch((e) => showError(e))

    const SetStatus = async (assignmentId, taskItem, status) =>
        await ToDoListWorkFlows
            .SetTaskStatus(assignmentId, taskItem.id, status)
            .then(async (e) => {
                showToast(`Status has been updated`,
                    <GrStatusGood className='me-2' />, 3);
                await LoadToDoLists()
            })

    return (
        <ToDoListContext.Provider
            value={{
                extendedModal: (m) => setModal(m),
                ToDoLists,
                LoadToDoLists,
                GetItemDetails,
                SetStatus,
                // External common calls
                showError,
                showToast,
                loading
            }}>
            <GeneralModal {...modal} onClose={() => setModal({ show: false })}>{modal.component}</GeneralModal>
            {children}
        </ToDoListContext.Provider>
    )
}

export default ToDoListContext